import * as types from '../constant';
//actions get slide and background
export function getList(payload){
  return ({
    type: types.GET_LIST_FAQ_REQUEST,
    payload
  });
}